export const GridIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M25.5 5.5H6.5C5.94772 5.5 5.5 5.94772 5.5 6.5V25.5C5.5 26.0523 5.94772 26.5 6.5 26.5H25.5C26.0523 26.5 26.5 26.0523 26.5 25.5V6.5C26.5 5.94772 26.0523 5.5 25.5 5.5Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 5.5V26.5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.5 16H5.5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ListIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="currentColor"
  >
    <path
      d="M12 8H27"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.0007 16H27"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.0007 24H27"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 8H7"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.00073 16H6.99996"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.00073 24H6.99996"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M6.45091 7.80089C6.96956 8.86123 7.82906 9.71682 8.89174 10.2306C8.9695 10.2675 9.0555 10.2834 9.1413 10.277C9.22709 10.2705 9.30972 10.2417 9.38104 10.1936L10.9458 9.15022C11.015 9.10408 11.0946 9.07592 11.1774 9.06831C11.2603 9.06071 11.3437 9.07388 11.4201 9.10665L14.3474 10.3612C14.4469 10.4034 14.5299 10.4769 14.584 10.5704C14.6381 10.6639 14.6603 10.7725 14.6473 10.8798C14.5548 11.6038 14.2016 12.2692 13.6537 12.7515C13.1059 13.2338 12.401 13.4999 11.6711 13.4999C9.4168 13.4999 7.25479 12.6044 5.66074 11.0103C4.06668 9.41629 3.17114 7.25428 3.17114 4.99994C3.17118 4.27005 3.43726 3.5652 3.91957 3.01736C4.40187 2.46953 5.06733 2.11628 5.79133 2.02375C5.89859 2.01077 6.00716 2.033 6.10069 2.08709C6.19421 2.14118 6.26763 2.2242 6.30987 2.32364L7.56553 5.25351C7.59801 5.32929 7.61124 5.41193 7.60405 5.49407C7.59686 5.5762 7.56947 5.65529 7.52432 5.72427L6.48455 7.31301C6.43722 7.38448 6.40925 7.467 6.40335 7.55251C6.39746 7.63803 6.41384 7.72361 6.45091 7.80089V7.80089Z"
      stroke="#334155"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M8.67114 8.5C9.77571 8.5 10.6711 7.60457 10.6711 6.5C10.6711 5.39543 9.77571 4.5 8.67114 4.5C7.56657 4.5 6.67114 5.39543 6.67114 6.5C6.67114 7.60457 7.56657 8.5 8.67114 8.5Z"
      stroke="#334155"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.6711 6.5C13.6711 11 8.67114 14.5 8.67114 14.5C8.67114 14.5 3.67114 11 3.67114 6.5C3.67114 5.17392 4.19793 3.90215 5.13561 2.96447C6.07329 2.02678 7.34506 1.5 8.67114 1.5C9.99723 1.5 11.269 2.02678 12.2067 2.96447C13.1444 3.90215 13.6711 5.17392 13.6711 6.5V6.5Z"
      stroke="#334155"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.5 21.75C8.32843 21.75 9 21.0784 9 20.25C9 19.4216 8.32843 18.75 7.5 18.75C6.67157 18.75 6 19.4216 6 20.25C6 21.0784 6.67157 21.75 7.5 21.75Z"
      fill="#2463AE"
    />
    <path
      d="M17.25 21.75C18.0784 21.75 18.75 21.0784 18.75 20.25C18.75 19.4216 18.0784 18.75 17.25 18.75C16.4216 18.75 15.75 19.4216 15.75 20.25C15.75 21.0784 16.4216 21.75 17.25 21.75Z"
      fill="#2463AE"
    />
    <path
      d="M3.96429 6.75H20.7857L18.3108 15.4121C18.2213 15.7255 18.0321 16.0012 17.7718 16.1975C17.5116 16.3938 17.1945 16.5 16.8685 16.5H7.88145C7.55549 16.5 7.23839 16.3938 6.97816 16.1975C6.71792 16.0012 6.52872 15.7255 6.43917 15.4121L3.04827 3.54396C3.0035 3.38725 2.90889 3.24939 2.77878 3.15124C2.64866 3.05309 2.49011 3 2.32713 3H0.75"
      stroke="#2463AE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SocialPhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#0F172A"
    />
    <path
      d="M23.9779 21.3087C23.9779 21.5727 23.9193 21.844 23.7946 22.108C23.6699 22.372 23.5086 22.6213 23.2959 22.856C22.9366 23.252 22.5406 23.538 22.0933 23.7213C21.6533 23.9047 21.1766 24 20.6633 24C19.9153 24 19.1159 23.824 18.2726 23.4647C17.4293 23.1053 16.5859 22.6213 15.7499 22.0127C14.9066 21.3967 14.1073 20.7147 13.3446 19.9593C12.5893 19.1967 11.9073 18.3973 11.2986 17.5613C10.6973 16.7253 10.2133 15.8893 9.86125 15.0607C9.50925 14.2247 9.33325 13.4253 9.33325 12.6627C9.33325 12.164 9.42125 11.6873 9.59725 11.2473C9.77325 10.8 10.0519 10.3893 10.4406 10.0227C10.9099 9.56068 11.4233 9.33334 11.9659 9.33334C12.1713 9.33334 12.3766 9.37734 12.5599 9.46534C12.7506 9.55334 12.9193 9.68534 13.0513 9.87601L14.7526 12.274C14.8846 12.4573 14.9799 12.626 15.0459 12.7873C15.1119 12.9413 15.1486 13.0953 15.1486 13.2347C15.1486 13.4107 15.0973 13.5867 14.9946 13.7553C14.8993 13.924 14.7599 14.1 14.5839 14.276L14.0266 14.8553C13.9459 14.936 13.9093 15.0313 13.9093 15.1487C13.9093 15.2073 13.9166 15.2587 13.9313 15.3173C13.9533 15.376 13.9753 15.42 13.9899 15.464C14.1219 15.706 14.3493 16.0213 14.6719 16.4027C15.0019 16.784 15.3539 17.1727 15.7353 17.5613C16.1313 17.95 16.5126 18.3093 16.9013 18.6393C17.2826 18.962 17.5979 19.182 17.8473 19.314C17.8839 19.3287 17.9279 19.3507 17.9793 19.3727C18.0379 19.3947 18.0966 19.402 18.1626 19.402C18.2873 19.402 18.3826 19.358 18.4633 19.2773L19.0206 18.7273C19.2039 18.544 19.3799 18.4047 19.5486 18.3167C19.7173 18.214 19.8859 18.1627 20.0693 18.1627C20.2086 18.1627 20.3553 18.192 20.5166 18.258C20.6779 18.324 20.8466 18.4193 21.0299 18.544L23.4573 20.2673C23.6479 20.3993 23.7799 20.5533 23.8606 20.7367C23.9339 20.92 23.9779 21.1033 23.9779 21.3087Z"
      stroke="white"
      stroke-miterlimit="10"
    />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#0F172A"
    />
    <path
      d="M13.337 16.041C13.337 14.567 14.5312 13.3717 16.0048 13.3717C17.4784 13.3717 18.6733 14.567 18.6733 16.041C18.6733 17.515 17.4784 18.7102 16.0048 18.7102C14.5312 18.7102 13.337 17.515 13.337 16.041ZM11.8944 16.041C11.8944 18.3118 13.7346 20.1525 16.0048 20.1525C18.275 20.1525 20.1152 18.3118 20.1152 16.041C20.1152 13.7702 18.275 11.9294 16.0048 11.9294C13.7346 11.9294 11.8944 13.7702 11.8944 16.041ZM19.3173 11.7664C19.3172 11.9564 19.3735 12.1422 19.479 12.3003C19.5845 12.4583 19.7344 12.5816 19.9099 12.6544C20.0854 12.7271 20.2786 12.7463 20.4649 12.7093C20.6513 12.6723 20.8225 12.5808 20.9568 12.4465C21.0912 12.3122 21.1828 12.141 21.2199 11.9546C21.2571 11.7682 21.2381 11.575 21.1655 11.3994C21.0929 11.2238 20.9698 11.0737 20.8119 10.9681C20.654 10.8624 20.4683 10.806 20.2783 10.8059H20.2779C20.0232 10.8061 19.779 10.9073 19.5989 11.0874C19.4188 11.2674 19.3175 11.5117 19.3173 11.7664ZM12.7709 22.5586C11.9904 22.523 11.5662 22.393 11.2843 22.2831C10.9106 22.1376 10.644 21.9643 10.3636 21.6842C10.0832 21.4041 9.90969 21.1377 9.76483 20.7638C9.65494 20.482 9.52495 20.0575 9.48947 19.2769C9.45066 18.4329 9.44291 18.1793 9.44291 16.041C9.44291 13.9028 9.4513 13.6499 9.48947 12.8052C9.52501 12.0246 9.65597 11.6009 9.76483 11.3183C9.91033 10.9444 10.0836 10.6777 10.3636 10.3973C10.6436 10.1168 10.91 9.94322 11.2843 9.79832C11.5661 9.6884 11.9904 9.55836 12.7709 9.52288C13.6146 9.48406 13.8681 9.47631 16.0048 9.47631C18.1415 9.47631 18.3952 9.4847 19.2397 9.52288C20.0201 9.55843 20.4436 9.68942 20.7262 9.79832C21.1 9.94322 21.3666 10.1172 21.647 10.3973C21.9273 10.6773 22.1002 10.9444 22.2457 11.3183C22.3556 11.6001 22.4856 12.0246 22.5211 12.8052C22.5599 13.6499 22.5676 13.9028 22.5676 16.041C22.5676 18.1793 22.5599 18.4322 22.5211 19.2769C22.4856 20.0575 22.3549 20.4819 22.2457 20.7638C22.1002 21.1377 21.9269 21.4044 21.647 21.6842C21.367 21.964 21.1 22.1376 20.7262 22.2831C20.4445 22.3931 20.0201 22.5231 19.2397 22.5586C18.3959 22.5974 18.1425 22.6052 16.0048 22.6052C13.8671 22.6052 13.6144 22.5974 12.7709 22.5586ZM12.7046 8.08237C11.8524 8.12118 11.2701 8.25634 10.7616 8.45428C10.2349 8.65869 9.7891 8.93291 9.34359 9.37785C8.89807 9.82279 8.62463 10.2695 8.42028 10.7963C8.22241 11.3053 8.08728 11.8874 8.04848 12.7398C8.00903 13.5936 8 13.8665 8 16.041C8 18.2155 8.00903 18.4884 8.04848 19.3422C8.08728 20.1946 8.22241 20.7767 8.42028 21.2857C8.62463 21.8122 8.89814 22.2594 9.34359 22.7041C9.78904 23.1489 10.2349 23.4227 10.7616 23.6277C11.2711 23.8256 11.8524 23.9608 12.7046 23.9996C13.5585 24.0384 13.831 24.0481 16.0048 24.0481C18.1786 24.0481 18.4515 24.0391 19.305 23.9996C20.1572 23.9608 20.7392 23.8256 21.248 23.6277C21.7743 23.4227 22.2205 23.1491 22.666 22.7041C23.1115 22.2592 23.3844 21.8122 23.5893 21.2857C23.7872 20.7767 23.923 20.1946 23.9611 19.3422C23.9999 18.4878 24.009 18.2155 24.009 16.041C24.009 13.8665 23.9999 13.5936 23.9611 12.7398C23.9223 11.8873 23.7872 11.3049 23.5893 10.7963C23.3844 10.2698 23.1108 9.8235 22.666 9.37785C22.2212 8.93221 21.7743 8.65869 21.2486 8.45428C20.7392 8.25634 20.1572 8.12054 19.3057 8.08237C18.4522 8.04355 18.1793 8.03387 16.0054 8.03387C13.8316 8.03387 13.5585 8.04291 12.7046 8.08237Z"
      fill="white"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#0F172A"
    />
    <path
      d="M19.915 17.0417L20.3709 14.1448H17.5623V12.2619C17.5623 11.4697 17.9544 10.6957 19.2083 10.6957H20.5031V8.22887C19.7491 8.10863 18.9871 8.04357 18.2234 8.03424C15.9118 8.03424 14.4027 9.42383 14.4027 11.936V14.1448H11.8403V17.0417H14.4027V24.0485H17.5623V17.0417H19.915Z"
      fill="white"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#0F172A"
    />
    <path
      d="M23.9421 10.9338C23.4137 11.1614 22.8582 11.3199 22.2894 11.4054C22.5553 11.3597 22.9467 10.8806 23.1024 10.6866C23.3391 10.3941 23.5195 10.0602 23.6343 9.70176C23.6343 9.67514 23.6609 9.63711 23.6343 9.6181C23.6209 9.61078 23.6059 9.60694 23.5907 9.60694C23.5754 9.60694 23.5604 9.61078 23.547 9.6181C22.9293 9.95289 22.2719 10.2084 21.5903 10.3786C21.5666 10.3859 21.5413 10.3865 21.5172 10.3805C21.4931 10.3745 21.4711 10.362 21.4536 10.3444C21.4005 10.2812 21.3434 10.2215 21.2826 10.1657C21.0046 9.9164 20.6892 9.71237 20.348 9.56106C19.8873 9.3719 19.3897 9.28999 18.8928 9.32149C18.4107 9.35197 17.9399 9.48141 17.5099 9.70176C17.0864 9.93407 16.7142 10.2497 16.4157 10.6296C16.1017 11.0207 15.875 11.4745 15.7508 11.9605C15.6484 12.4229 15.6368 12.9007 15.7166 13.3675C15.7166 13.4474 15.7166 13.4588 15.6482 13.4474C12.9393 13.0481 10.7167 12.086 8.90068 10.0212C8.8209 9.92992 8.77911 9.92992 8.71452 10.0212C7.92426 11.2228 8.30799 13.1242 9.29581 14.0634C9.42879 14.1889 9.56556 14.3106 9.70993 14.4247C9.25703 14.3925 8.81518 14.2696 8.41057 14.0634C8.33459 14.014 8.2928 14.0406 8.289 14.1319C8.27823 14.2584 8.27823 14.3856 8.289 14.5121C8.36827 15.1185 8.60703 15.6929 8.98085 16.1767C9.35467 16.6604 9.85014 17.0361 10.4166 17.2653C10.5547 17.3245 10.6986 17.3691 10.8459 17.3984C10.4266 17.481 9.99662 17.4938 9.57316 17.4364C9.48198 17.4174 9.44778 17.4668 9.48198 17.5543C10.0405 19.0753 11.2524 19.5393 12.1415 19.7979C12.2631 19.8169 12.3846 19.8169 12.5214 19.8473C12.5214 19.8473 12.5214 19.8473 12.4986 19.8701C12.2365 20.3492 11.1765 20.6725 10.6902 20.8398C9.80251 21.1589 8.85612 21.2809 7.91667 21.1972C7.76849 21.1744 7.7343 21.1782 7.69631 21.1972C7.65831 21.2162 7.69631 21.2581 7.7381 21.2961C7.92806 21.4216 8.11803 21.5319 8.31559 21.6383C8.90374 21.9594 9.52553 22.2145 10.1696 22.3989C13.5054 23.3191 17.2591 22.6423 19.7629 20.1515C21.7309 18.1969 22.4224 15.5008 22.4224 12.8009C22.4224 12.6983 22.5477 12.6374 22.6199 12.5842C23.1178 12.1959 23.5568 11.7373 23.9231 11.2228C23.9865 11.1461 24.0191 11.0485 24.0143 10.949C24.0143 10.892 24.0143 10.9034 23.9421 10.9338Z"
      fill="white"
    />
  </svg>
);
